import * as ko from "knockout";
import baoMenu from "../../services/bao-menu";
import Bao from "../../services/bao-service";
import template from "./toolbar.html";
export class ToolbarButton implements Interfaces.Bao.BaoMenuItem {

	public Enabled = ko.observable(true);
	public Visible = ko.observable(true);
	public Caption = ko.observable("");
	public ToolTip = ko.observable("");
	public ActionKey = ko.observable("");
	public Icon = ko.observable("");
	public TargetUrl = ko.observable("");
	public MethodInfo = ko.observable("");
	public AssemblyName = ko.observable("");
	public ReflectionType = ko.observable("");
	public Items: KnockoutObservableArray<Interfaces.Bao.BaoMenuItem> = ko.observableArray([]);

	constructor(text = "", icon = "") {
		this.Caption(text);
		this.Icon(icon);
	}
}

export interface IToolbarParams {
	/**
	 * Name of the BAO Form
	 */
	formName: string | KnockoutObservable<string>;

	/**
	 * optional: name of the toolbar
	 */
	toolbarName?: string | KnockoutObservable<string>;

	/**
	 * optional: application id
	 */
	applicationId?: string | KnockoutObservable<string>;

	/**
	 * optional: click handler
	 */
	click?: (item: Interfaces.Bao.BaoMenuItem, args) => void;

	/**
	 * optional: name of the function in the viewmodel
	 */
	enable?: string;

	/**
	 * optional: name of the function in the viewmodel
	 */
	show?: string;

	/**
	 * optional: handler which should be called after toolbar was loaded
	 */
	loaded?: (buttons) => void;

	/**
	 * optional: observable array for the buttons / items
	 */
	buttons?: KnockoutObservableArray<Interfaces.Bao.BaoMenuItem>;

	/**
	 * optional: viewmodel of the context - used by old binding
	 */
	viewModel?: any;

	/**
	 * optional: is used by main tabcontroller for displaying permissions
	 */
	context?: KnockoutObservable<{ Container: KnockoutObservableArray<Interfaces.Bao.BaoMenuItem> }>;
}

export class ToolbarComponent {

	public Buttons = ko.pureComputed(() => {
		if (this.context != null && this.context() != null && this.context().Container() != null && this.context().Container().length > 0) {
			return ko.unwrap(this.context().Container()[0].Items);
		} else {
			return this.InternalButtons();
		}
	});
	private InternalButtons = ko.observableArray<Interfaces.Bao.BaoMenuItem>();
	private context: KnockoutObservable<{ Container: KnockoutObservableArray<Interfaces.Bao.BaoMenuItem> }>;

	private clickHandler: (btn: Interfaces.Bao.BaoMenuItem, args: any) => void;

	public constructor(params: IToolbarParams) {
		const toolbarName = ko.unwrap(params.toolbarName);
		const applicationId = ko.unwrap(params.applicationId);
		const formName = ko.unwrap(params.formName);
		const clickHandler = params.click;
		const enableButton = params.enable;
		const showButton = params.show;
		const loaded = params.loaded;
		let buttons: KnockoutObservableArray<Interfaces.Bao.BaoMenuItem> = params.buttons;
		const url = "Bao/LoadBootstrapToolbar";
		if (clickHandler != null) {
			this.clickHandler = clickHandler;
		} else {
			this.clickHandler = baoMenu.clickHandler;
		}

		if (params.context != null) {
			// main tab mode
			this.context = params.context;
			this.Buttons.notifySubscribers();
		} else {
			if (buttons == null || ko.isObservable(buttons) == false) {
				buttons = ko.observableArray<Interfaces.Bao.BaoMenuItem>([]);
			}
			this.InternalButtons = buttons;
			this.InternalButtons.notifySubscribers();
			if (formName == null || formName == "") {
				this.InitButtons(enableButton, showButton, loaded, params.viewModel);
			} else {
				this.LoadButtons(url, formName, toolbarName, applicationId).then((returnValue: Interfaces.Bao.BaoMenuItem[]) => {
					ko.map.fromJS(returnValue, buttons);
					this.InitButtons(enableButton, showButton, loaded, params.viewModel);
				});
			}
		}
	}
	public ButtonType(btn: Interfaces.Bao.BaoMenuItem) {
		const items = ko.unwrap(btn.Items);
		if (items != null && items.length > 0) {
			return "container";
		}
		return "button";
	}

	public GetIcon(iconObs: KnockoutObservable<string>) {
		const icon = ko.unwrap(iconObs);
		if (icon != null && icon != "") {
			if (icon.indexOf("fal ") < 0) {
				return icon + " fal";
			}
			return icon;
		}
		return "";
	}

	public ButtonClickHandler = (item: Interfaces.Bao.BaoMenuItem, args) => {
		if (ko.unwrap(item.TargetUrl).startsWith("#") || ko.unwrap(item.TargetUrl).startsWith("https://") || ko.unwrap(item.TargetUrl).startsWith("http://")) {
			return true;
		}
		if (ko.unwrap(item.Enabled) == true) {
			this.clickHandler(item, args);
		}
	}

	public dispose() {

	}

	private TargetUrlHasValidHref(targetUrl: string): boolean {
		return (targetUrl.startsWith("#") || targetUrl.startsWith("https://") || targetUrl.startsWith("http://"));
	}

	private TargetUrlsTarget(targetUrl: string): string {
		if (targetUrl.startsWith("https://") || targetUrl.startsWith("http://")) {
			return "_blank";
		}
		return "_self";
	}

	private InitButtons(enableButton: string, showButton: string, loaded: (btns: KnockoutObservableArray<Interfaces.Bao.BaoMenuItem>) => void, viewModel: any) {
		if (enableButton != null && typeof enableButton === "string" && viewModel != null) {
			viewModel[enableButton] = function (actionKey, enable) {
				if (actionKey != null && enable != null) {
					ko.utils.arrayForEach(this.Buttons(), (btn: Interfaces.Bao.BaoMenuItem) => {
						if (ko.unwrap(btn.ActionKey) === actionKey) {
							const obs = (btn.Enabled) as KnockoutObservable<boolean>;
							obs(enable);
						}
					});
				}
			};
		}
		if (showButton != null && typeof showButton === "string" && viewModel != null) {
			viewModel[showButton] = function (actionKey, show) {
				if (actionKey != null && show != null) {
					ko.utils.arrayForEach(this.Buttons(), (btn: Interfaces.Bao.BaoMenuItem) => {
						if (ko.unwrap(btn.ActionKey) === actionKey) {
							const obs = (btn.Visible) as KnockoutObservable<boolean>;
							obs(show);
						}
					});
				}
			};
		}
		if (loaded != null && typeof loaded === "function") {
			loaded(this.InternalButtons);
		}
	}

	private LoadButtons(url, formName, toolbarName, applicationId) {
		return Bao.post(url, JSON.stringify({
			formName: formName,
			toolbarName: toolbarName ? toolbarName : null,
			applicationId: applicationId ? applicationId : null
		}));
	}
}
const knockoutComponent: KnockoutComponentTypes.ComponentConfig = {
	template: template,
	viewModel:
	{
		createViewModel: function (params: IToolbarParams, componentInfo) {
			const vm = new ToolbarComponent(params);
			ko.utils.domNodeDisposal.addDisposeCallback(componentInfo.element, () => {
				if (vm != null) {
					vm.dispose();
				}
			});
			return vm;
		}
	}

};
export default knockoutComponent;
